import { GridDirection, GridWrap } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

import {
  Spacing,
  GridContentAlignment,
  GridItemsAlignment,
  GridJustification,
} from '../Grid.types';

interface StylesProps {
  alignContent?: GridContentAlignment;
  alignItems?: GridItemsAlignment;
  direction?: GridDirection;
  justifyContent?: GridJustification;
  spacing?: Spacing;
  wrap?: GridWrap;
}

export const useStyles = makeStyles<StylesProps>()(
  (
    { tokens },
    {
      alignContent = 'stretch',
      alignItems = 'stretch',
      direction = 'row',
      justifyContent = 'flex-start',
      wrap = 'wrap',
      spacing,
    },
  ) => {
    const sp = spacing ? tokens.spacing[spacing] : 0;

    return {
      container: {
        display: 'flex',
        alignContent,
        alignItems,
        justifyContent,
        flexDirection: direction,
        flexWrap: wrap,
        width: '100%',
      },
      spacing: {
        width: `calc(100% + ${sp}px)`,
        margin: `-${sp / 2}px`,

        '& > .MuiGrid-item': {
          padding: `${sp / 2}px`,
        },
      },
    };
  },
);
